



import React from 'react';


const MedicalDeviceLayout = () => {
    const facilities = [
        {
            country: 'Imaging',
           
            locations: [
                { name: 'Siemens PET-CT', image: 'https://marketing.webassets.siemens-healthineers.com/008a97c32df2c5af/846894726f5c/v/1583a8f24e36/siemens-healthineers_mi_biograph_vision_pet-ct_25yr.jpg' },
                { name: 'GE 128-slice/256-layer high-end CT; Philips 128-slice CT', image: 'https://5.imimg.com/data5/SELLER/Default/2024/12/471804252/MA/YU/NT/227320296/ct-scan-philips-128-slice.jpg' },
                { name: 'GE 3.0T quantitative MRI', image: 'https://www.itnonline.com/sites/default/files/GE%20SIGNA_Sprint_side.jpg' },
                { name: 'Siemens DSA', image: 'https://marketing.webassets.siemens-healthineers.com/1800000006147478/6cd8aaef0873/v/be01900499bd/siemens-healthineers_at_artis-icono-biplane-neuro.jpg' },
                
            ]
        },
        {
            country: 'Ultrasound',
           
            locations: [
                { name: 'GE Logiq E11 premium whole-body system', image: 'https://srv.elzhen.com/media/staticFileImageModel/images/GE__1_Logiq%20E11%20R1.5.2.png' },
                { name: 'GE Voluson E8 4D ultrasound; Philips EPIQ 7C cardiovascular ultrasound', image: 'https://www.gehealthcare.com/-/jssmedia/global/products/images/ultrasound/voluson/e8/voluson-e8-product.jpg?h=673&iar=0&w=600&rev=9722aa99890a4590a28dfe34dcd78046&hash=89131ECEB3F1DE521D606E38C59C14A4' }
            ]
        },
        {
            country: 'Laboratory',
           
            locations: [
                { name: 'Mindray fully automated hematology line', image: 'https://www.mindray.com/content/xpace/en/products/laboratory-diagnostics/hematology/5-part-differential-analyzers/bc-6000.thumb.319.319.png' },
               
            ]
        },
        {
            country: 'Operation Theaters',
            
            locations: [
                { name: 'Olympus laparoscopy systems; Karl Storz endoscopy systems', image: 'https://www.karlstorz.com/static_2x/static/file_img/HM_OR1/3713558_rdax_620x349_75.webp' },
               
            ]
        },

        {
            country: 'Oncology Devices',
            
            locations: [
                { name: 'CYBERKNIFE', image: 'assets/imgs/medical-devices/cyberknife_oncology.jpg' },
                { name: 'Canon Aquilion Lightning Diagnostic-Grade Simulated Positioning Large-Aperture CT from Japan', image: 'assets/imgs/medical-devices/Canon Aquilion Lightning Diagnostic-Grade Simulated Positioning Large-Aperture CT from Japan.PNG' },
               { name: 'Varian VitalBeam Intelligent Full-Function Precision Linear Accelerator System from the USA', image: 'assets/imgs/medical-devices/Varian-TrueBeam-imaging-system.jpg' },
               
            ]
        },
        {
            country: 'Surgical Devices',
            
            locations: [
                { name: 'DA VINCI XI ROBOT', image: 'assets/imgs/medical-devices/Img128_Xi_Trio_of_System_Components_High_Res_184859-1024x687.jpg' },
                { name: 'TINAVI ORTHOPEDIC ROBOT', image: 'assets/imgs/medical-devices/TINAVI-robot.png.webp' },
                { name: 'SKYWALKER™ ORTHOPEDIC SURGICAL ROBOT', image: 'assets/imgs/medical-devices/SkyWalker™-Orthopedic-Surgical-Robot-copy.webp' },

               
            ]
        },

        
        
    ];

  

    


    
    return(
        
        <Cards facilities={facilities} />
    )

};

export default MedicalDeviceLayout;






const Cards = ({ facilities }) => {
 return (
    <div className="min-h-screen bg-white p-8">
      <div className=" mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 my-4">Advanced diagnostic & treatment device</h1>
          

        </div>

        {facilities.map((facility, index) => (
          <div key={index} className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 pl-2 border-l-4 border-blue-500">
              {facility.country}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {facility.locations.map((location, locIndex) => (
                <div
                  key={locIndex}
                  className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                >
                  {/* <Link to={`/medtrust-hospital`}> */}
                    
                  <div className="relative h-64 sm:h-72 md:h-80 lg:h-96 overflow-hidden">
                    <img
                      src={location.image}
                      alt="Hospital facility"
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                    
                   
                    {/* Hospital name from bottom on hover */}
                    {location.name && (
                        <div className="absolute bottom-0 left-0 right-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
                      <div className="successfull-experience backdrop-blur-md p-6 border-t border-white/20">
                        <h3 className="text-sm md:text-lg font-bold text-white leading-tight">
                          {location.name}
                        </h3>
                      </div>
                    </div>

                    )}
                    
                  </div>
                  {/* </Link> */}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};





